import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
  userID: any;
  showLoader: boolean = false;
  updating: boolean = false;
  user: any;
  currentOrg: any;
  currentRole: any;
  currentActiveValue: any;
  currentUserType: any;
  username: any;
  roles: any = [];
  orgs: any = [];
  currentUserRole: any;
  currentUserOrg: any;
  oldRoleId:any;

  editUser = new FormGroup({
    username: new FormControl('', [
      Validators.required,
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      // Validators.pattern('^[a-zA-Z0-9-_]([.](?![.])|[a-zA-Z0-9-_])*([@](?![@])|[a-zA-Z])([.](?![.])|[a-zA-Z])*[a-zA-Z]$'),
    ]),
    displayName: new FormControl('', [
      Validators.required
    ]),
    mobile: new FormControl('', [
      Validators.required,
    ]),
    type: new FormControl('', [
      Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
    // organization: new FormControl('', [
    //   Validators.required,
    // ]),
    role: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(public globals: Globals, private toastrService: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private userService: UserService
    , private roleService: RoleService
    , private orgService: OrgService
  ) { }

  ngOnInit(): void {
    // this.user = {
    //   id: 1,
    //   username: "user1",
    //   type: "student",
    //   email: "user1@domain.com",
    //   displayName: "user1",
    //   mobile: "xxxxxxxxxxx",
    //   active: true,
    //   organization: "organization1",
    //   role: "role1"
    // };
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.username = params['userName'] || "";

        if (this.username != "") {
          this.showLoader = true;
          this.getUserByName();
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_USER'));
          this.router.navigate(['/users']);
        }
      });
    // this.activatedRoute
    //   .queryParams
    //   .subscribe(params => {
    //     this.userID = params['userID'] || "";

    //     if (this.userID != "") {
    //       this.showLoader = true;
    //       // Get User
    //       this.getUserInfo();
    //     } else {
    //       console.log("no user");
    //       this.router.navigate(['/user']);
    //     }
    //   });
  }

  getUserByName() {
    this.showLoader = true;
    this.userService.getUserByUsername(this.username)
      .subscribe(
        data => {
          if (data) {
            this.user = data;
            this.userID = data.id;
            this.editUser.controls.username.setValue(data.username)
            this.editUser.controls.email.setValue(data.email)
            this.editUser.controls.displayName.setValue(data.displayName)
            this.editUser.controls.mobile.setValue(data.mobile)
            this.editUser.controls.type.setValue(data.userType)
            this.editUser.controls.active.setValue(data.active)
            this.currentActiveValue = data.active
            this.currentUserType = data.userType
            // if (data.userOrgs.length > 0) {
            //   this.currentUserOrg = data.userOrgs[0]
            //   this.currentOrg = this.currentUserOrg.orgid;
            //   this.editUser.controls.organization.setValue(this.currentRole)
            // }

            if (data.userRoles.length > 0) {
              this.currentUserRole = data.userRoles[0]
              this.currentRole = this.currentUserRole.roleid;
              this.oldRoleId=this.currentUserRole.roleid;
              this.editUser.controls.role.setValue(this.currentRole)
            } else {
              this.currentUserRole = {
                userid: this.userID,
                roleid: 0,
                grantedFrom: new Date(),
                grantedTo: new Date(),
                active: "YES"
              };
            }

            // this.editUser.controls.organization.setValue(data.organization)
            // this.editUser.controls.role.setValue(data.role)
            this.getAllRoles();

          } else {
            this.toastrService.warning(this.translate.instant("NOT_FOUND"));
            this.showLoader = false;
          }
        },
        error => {
          this.toastrService.warning(this.translate.instant("CAN_NOT_GET_USER"));
          this.showLoader = false;
        }
      );
  }

  editUserChange() {

  }

  editUserSubmit() {

    if (this.editUser.valid) {
      let username = this.editUser.controls.username.value
      let email = this.editUser.controls.email.value
      let displayName = this.editUser.controls.displayName.value
      let mobile = this.editUser.controls.mobile.value
      let userType = this.editUser.controls.type.value
      let active = this.editUser.controls.active.value
      // let orgid = this.editUser.controls.organization.value
      // let roleId = this.editUser.controls.role.value

      // Update user info
      this.updateUser(username, email, displayName, mobile, userType, active,
        // orgid, roleId
      );

    }
    else {
      this.editUser.markAllAsTouched();
      this.editUser.markAsDirty();
    }
  }

  getUserInfo() {

  }



  updateUser(username: string, email: string, displayName: string, mobile: string, userType: string, active: string
    // , orgid: number, roleId: number
  ) {
    this.updating = true;
    let candidateid = 0;
    let studentid = 0;
    let teacherid = 0;
    if (userType == "candidate") {
      candidateid = 1;
    } else if (userType == "student") {
      studentid = 1;
    } else if (userType == "teacher") {
      teacherid = 1;
    }

    // let userOrgs = [];
    // if (typeof this.currentUserOrg.id != 'undefined') {
    //   userOrgs.push(this.currentUserOrg)
    // }

    let userRoles = [];
    if (typeof this.currentUserRole.userid != 'undefined') {
      userRoles.push(this.currentUserRole)
    }

    this.user.username = username;
    this.user.displayName = displayName;
    this.user.email = email;
    this.user.mobile = mobile;
    this.user.userType = userType;
    this.user.candidateid = candidateid;
    this.user.studentid = studentid;
    this.user.teacherid = teacherid;
    this.user.active = active;
    this.user.userRoles = null;
    this.user.userOrgs=null;
    
    this.userService.updateAllUser(this.user).subscribe(
      data => {
        console.log("new"+this.editUser.controls.role.value);
        console.log("old"+this.oldRoleId);
        if(this.oldRoleId!=this.editUser.controls.role.value){
          this.userService.deleteRoleByUser(this.user.id).subscribe(
            data =>{
              this.userService.UpdateUserRole(this.user.id,this.editUser.controls.role.value,"YES").subscribe(
                data =>{
                  this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
                  this.router.navigate(['/users']);
                  this.updating = false;
                },
                error => {
                  this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
                  this.updating = false;
                }
              );
          },
          error => {
            this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
            this.updating = false;
          }
        );
        }else{
        this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
        this.router.navigate(['/users']);
        this.updating = false;
        }
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
        this.updating = false;
      }
    );


  }

  getAllRoles() {
    this.roleService.getAllRoles().subscribe(
      data => {
        this.roles = data;
        this.getAllOrgs();
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_ROLES"));
        this.showLoader = false;
      }
    );
  }

  getAllOrgs() {
    this.orgService.getAllOrgs().subscribe(
      data => {
        this.orgs = data;
        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_ORGS"));
        this.showLoader = false;
      }
    );
  }

  // addUserRole(userid: number, roleid: number, username: string, orgid: number) {

  //   this.userService.addUserRole(userid, roleid, new Date(), new Date, "YES")
  //     .subscribe(
  //       data => {
  //         this.addUserOrg(username, orgid);
  //       },
  //       error => {
  //         this.updating = false;
  //         this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_USER_ROLE'));
  //       }
  //     );
  // }

  // addUserOrg(username: string, orgid: number) {

  //   this.userService.addUserOrg(username, orgid)
  //     .subscribe(
  //       data => {
  //         this.updating = false;
  //         this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
  //         this.router.navigate(['/users']);

  //       },
  //       error => {
  //         this.updating = false;
  //         this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_USER_ORG'));
  //       }
  //     );
  // }

  // changeOrg() {
  //   this.currentUserOrg.orgid = this.editUser.controls.organization.value;

  // }

  changeRole() {
    this.currentUserRole.roleid = this.editUser.controls.role.value;
  }

  resetPassword(){
    this.showLoader = true;
    this.userService.restPass(this.username,this.globals.currentUserInfo.username).subscribe(
      data => {
        this.router.navigate(['/users']);
          this.toastrService.success(this.translate.instant('PASSWORD_REST_SUSSCESFULLY'));
        },
      error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
      },
      
    );
  }
}
